import { IColorSpecifiedFeature } from "../../../../base/domain/drawing";

export interface IPaintStyleOnEditingSpecifiable {
  paintStyleOnEditing: IColorSpecifiedFeature;
}

export function instanceOfIPaintStyleOnEditingSpecifiable(instance: any): instance is IPaintStyleOnEditingSpecifiable {
  return instance
      && (instance.paintStyleOnEditing !== undefined);
}
